<template>
  <v-footer class="justify-center" color="primary" height="200">
    <v-row>
      <v-col cols="12" md="4">
        <v-btn icon class="mx-2" href="https://www.linkedin.com/in/alexandro-lahmann" target="_blank">
          <v-icon color="white" large>mdi-linkedin</v-icon>
        </v-btn>
        <v-btn icon class="mx-2" href="https://www.xing.com/profile/Alexandro_Lahmann" target="_blank">
          <v-icon color="white" large>mdi-xing</v-icon>
        </v-btn>
        <v-btn icon class="mx-2" href="https://twitter.com/_alahmann" target="_blank">
          <v-icon color="white" large>mdi-twitter</v-icon>
        </v-btn>

      </v-col>
      <v-col cols="12" md="4">
        <div class="title font-weight-light white--text text-center" @click="sheet = !sheet">{{ $t('footerImprint') }}</div>
      </v-col>
      <v-col cols="12" md="4">
        <div
          class="title font-weight-light white--text float-right"
        >&copy; {{ (new Date()).getFullYear() }} — All rights reserved</div>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
          class="text-center"
      >
        <v-btn
            class="mt-6"
            text
            color="red"
            @click="sheet = !sheet"
        >
          close
        </v-btn>
        <div class="py-3" style="height: 150px; overflow: auto" v-html="$t('imprintText')"></div>
      </v-sheet>
    </v-bottom-sheet>

  </v-footer>
</template>

<script>
export default {
  data: () => ({
    sheet: false,
  }),
}
</script>